import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service';
import { Observable } from 'rxjs';
import { ROUTES } from '../../server-route';
import { HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class DpSpReceivingService extends ApiService {

  public addReceivingDetails(reqData: any): Observable<any> {
    return this.post<any>(ROUTES.RECEIVING_COUNT, {
      body: reqData
    });
  }

  public getReceivingReport(userId: string, startDate: string, endDate: string): Observable<any> {
    let params = {
      'userId': userId,
      'startDate': startDate,
      'endDate': endDate
    }
    return this.get<any>(ROUTES.RECEIVING_REPORT, { params })
  }

  print(id: string, details: any, workerName: any, receivingName: any) {
    console.log(id, details)
    const now = new Date();
    const formattedDate = `${now.getDate()}/${now.getMonth() + 1}/${now.getFullYear()}`;
    const formattedTime = `${now.getHours()}:${now.getMinutes()}:${now.getSeconds()}`;
    const printWindow = window.open('', '_blank');
    if (printWindow) {
      printWindow.document.write(
        `
        <html>
          <head>
            <title>Print</title>
            <style>
              body{
                font-family: Arial, sans-serif;
                font-size: 18px
              }
            </style>
          </head>
          <body>
            <h3><u>Receiving Summary</u></h3>
            <table>
              <tr>
                <td><b>Reference Number</b></td>
                <td>: ${id}</td>
              </tr>
              <tr>
                <td><b>Name</b></td>
                <td>: ${workerName}</td>
              </tr>
              <tr>
                <td><b>Family Code</b></td>
                <td>: ${details.workerFC}</td>
              </tr>
              <tr>
                <td><b>Diksha Patra Count</b></td>
                <td>: ${details.dpReceiveCount}</td>
              </tr>
              <tr>
                <td><b>Swastyayani Patra Count</b></td>
                <td>: ${details.spReceiveCount}</td>
              </tr>

              <tr>
                <td><b>Received By</b></td>
                <td>: ${receivingName}</td>
              </tr>

              <tr>
                <td><b>Receiving Date</b></td>
                <td>: ${formattedDate} ${formattedTime}</td>
              </tr>
            </table>
            <br>
            <span>This is a computer generated summary.</span>
            <span>No signature required.</span>
          </body>
        </html>
        `
      )
      printWindow.document.close();
      printWindow.print();
    }
  }
}
